
/**
 * Register global loading indicator methods
 */
export const registerGlobalLoadingIndicator = (
  startRequest: () => void,
  endRequest: () => void,
  endAllRequests: () => void
) => {
  // Expose methods globally for other components to use
  window._loadingIndicator = {
    startRequest,
    endRequest,
    endAllRequests
  };
  
  // Set up global error handling to clear loading state
  const originalOnError = window.onerror;
  window.onerror = function(message, source, lineno, colno, error) {
    // Make sure to end all loading states when an unhandled error occurs
    endAllRequests();
    
    // Call the original error handler if it exists
    if (typeof originalOnError === 'function') {
      return originalOnError(message, source, lineno, colno, error);
    }
    return false;
  };
  
  // Return cleanup function
  return () => {
    // Restore original error handler
    window.onerror = originalOnError;
    
    // Clean up global reference
    if (window._loadingIndicator) {
      // @ts-ignore - This is intentional, we're deleting a property
      delete window._loadingIndicator;
    }
  };
};

// Add TypeScript declaration for the global loading indicator
declare global {
  interface Window {
    _loadingIndicator?: {
      startRequest: () => void;
      endRequest: () => void;
      endAllRequests: () => void;
    };
  }
}
